import { selectorFamily, useRecoilValue } from 'recoil';
import { DisputeService } from 'services';
import { isAuthenticated, refreshState, useSetRefreshState } from 'state';
import { DisputeTrackingRecord } from 'types';
import { userInfo } from './userInfo';

export const disputeTracking = selectorFamily<DisputeTrackingRecord[], string>({
    key: 'disputeTracking',
    get: (disputeNumber) =>
        async ({ get }) => {
            get(refreshState(disputeTracking(disputeNumber).key));
            if (get(isAuthenticated)) {
                const service = new DisputeService();
                const { isInternalUser } = get(userInfo);
                
                // If the user isn't internal, no "IsPublic" flag should be passed to the service so as to get all the tracking records.
                const data = isInternalUser !== true 
                            ? await service.getDisputeTracking(disputeNumber, true) 
                            : await service.getDisputeTracking(disputeNumber);
                return data.map(({ eventDate, ...rest}) => ({
                    ...rest,
                    eventDate: eventDate ? new Date(eventDate) : null,
                } as DisputeTrackingRecord));
            }
            return [];
        }
});

export const useDisputeTracking = (disputeNumber: string) => useRecoilValue(disputeTracking(disputeNumber));

export const useRefreshDisputeTracking = (disputeNumber: string) =>
    useSetRefreshState(disputeTracking(disputeNumber));